import * as React from "react"
import { useEffect } from "react"
import cx from "classnames"

import * as styles from "./styles.module.scss"
import Button from "../../Button"
import { FlowQuestionId } from "types"

export interface InputOptionProps {
  answer: any
  flowKey: FlowQuestionId
  isDisabled?: boolean
  isSelected?: boolean
  onSelect: (shouldSelect?: boolean, value?: string) => void
  value?: string
}

const InputOption: React.FC<InputOptionProps> = ({
  answer,
  flowKey,
  isDisabled,
  isSelected,
  onSelect,
  value,
}) => {
  const [showOther, setShowOther] = React.useState<boolean>(false)
  const otherRef = React.useRef<HTMLDivElement>(null)

  const toggleOther = () => {
    setShowOther(!showOther)
  }

  const onClick = () => {
    // cannot click
    if (!isSelected && isDisabled) {
      return
      // show other text input
    } else if (answer.isOther) {
      toggleOther()
      // submit selection to parent
    } else {
      onSelect()
    }
  }

  const onSubmit = (e) => {
    e.preventDefault()
    toggleOther()
    const { value } = e.target.otheranswertext
    // select & submit value
    if (value) {
      onSelect(true, value)
      // deselect & clear value
    } else {
      onSelect(false)
    }
  }

  const bodyClickListener = (e) => {
    // close "other input" if user clicks anywhere else in document
    if (
      otherRef &&
      otherRef !== e.target &&
      !otherRef.current.contains(e.target)
    ) {
      toggleOther()
      onSelect(false)
    }
  }

  useEffect(() => {
    if (answer.isOther) {
      document.body.addEventListener("click", bodyClickListener)
    }
    return () => {
      if (answer.isOther) {
        document.body.removeEventListener("click", bodyClickListener)
      }
    }
  }, [])

  return (
    <li
      className={cx({
        [styles.listItem]: true,
        "bet-FlowPickMany-listItem": true,
        "bet-FlowPickMany-listItem--selected": isSelected,
        "bew-FlowPickManu-listItem--disabled": !isSelected && isDisabled,
      })}
      data-flow-value={answer.id}
      data-flow-display-value={answer.title}
      data-flow-key={flowKey}
      data-qa-answer-type="select"
      data-qa="answer"
    >
      {!showOther && (
        <Button
          heading={value || answer.title}
          subhead={
            (!answer.isOther || !value) && answer.detail ? answer.detail : null
          }
          active={isSelected}
          onClick={() => onClick()}
        />
      )}
      {showOther && (
        <form onSubmit={(e) => onSubmit(e)}>
          <div ref={otherRef} className={styles.otherInput}>
            <input
              name="otheranswertext"
              type="text"
              defaultValue={value || ""}
              placeholder={answer.title}
              autoFocus
            />
            <button type="submit">
              <i className="bsk-icon-checkmark-thick"></i>
            </button>
          </div>
        </form>
      )}
    </li>
  )
}

export default InputOption
